import { render, staticRenderFns } from "./RestrictionConciseView.vue?vue&type=template&id=3add91f4&scoped=true"
import script from "./RestrictionConciseView.vue?vue&type=script&lang=js"
export * from "./RestrictionConciseView.vue?vue&type=script&lang=js"
import style0 from "./RestrictionConciseView.vue?vue&type=style&index=0&id=3add91f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3add91f4",
  null
  
)

export default component.exports